import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { provideTranslocoLocale } from '@jsverse/transloco-locale';
import { I18Service } from './i18.service';
import {
  provideTransloco,
  provideTranslocoScope,
  TranslocoLoader,
  TranslocoModule,
  Translation,
} from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`assets/i18n/${lang}.json?ts=` + new Date().getTime());
  }
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['en-EN', 'de-DE'],
        defaultLang: 'en-EN',
        fallbackLang: 'en-EN',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        missingHandler: {
          allowEmpty: false,
          useFallbackTranslation: false,
          logMissingKey: true,
        },
        prodMode: environment.production,
      },
      loader: TranslocoHttpLoader,
    }),
    provideTranslocoLocale(),
    provideTranslocoScope('dto'),
    I18Service,
  ],
})
export class TranslocoRootModule {}
